<template>
    <div class="main">
        <el-dialog
            :close-on-click-modal="false"
            :title="openData.title"
            :visible.sync="openData.state"
            width="800px"
            class="dialog_container"
            @close="dialogVisibleClose"
        >
            <div class="content">
                <div class="itemContent">
                    <p class="name">姓名：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent">
                    <p class="name">餐饮类型：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent">
                    <p class="name">取餐方式：</p>
                    <div class="boxs"></div>
                </div>
                <div class="itemContent">
                    <p class="name">送餐人员：</p>
                    <div class="boxs">
                        <el-select
                            v-model="customerSex"
                            placeholder="请选择送餐人员"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in sexOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="footer">
                <el-button type="primary" @click="save">发 布</el-button>
                <el-button @click="dialogVisibleClose">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            sexOptions: [],
            customerSex: "",
        };
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取数据
        getList() {},
        // 提交
        save() {},
        // 关闭
        dialogVisibleClose() {
            this.$emit("cancleSend", false);
        },
    },
};
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
.itemContent {
    display: flex;
    line-height: 34px;
    margin-bottom: 24px;
    .name {
        width: 120px;
    }
    .boxs {
        flex: 1;
        width: 0;
    }
}
</style>